import { createContext } from 'react';
import { ActivityContextState } from './models';

export const ActivityContext = createContext<ActivityContextState>(undefined);
